__turbopack_context__.v({
  "component": "bCOKRa_component",
  "container": "bCOKRa_container",
  "logo": "bCOKRa_logo",
  "sticky": "bCOKRa_sticky",
});
